var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecommendationsSquareIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.341,
    y1: 0.837,
    x2: -0.083,
    y2: 0.352,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#d20255"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#f37d1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "#fbbf02"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1.337,
    y1: 0.894,
    x2: -1.165,
    y2: -0.283,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3568",
    "data-name": "Groupe 3568",
    transform: "translate(-1180 -558)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_3185",
    "data-name": "Groupe 3185",
    transform: "translate(1196.292 571.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2011",
    "data-name": "Trac\\xE9 2011",
    d: "M-286.77,2720.428a2.264,2.264,0,0,0,2.264,2.264,2.264,2.264,0,0,0,2.264-2.264,10.146,10.146,0,0,0-7.753-9.987,10.011,10.011,0,0,0-8.459,1.959,9.931,9.931,0,0,0-3.727,7.768v14.861a2.264,2.264,0,0,0,2.264,2.264,2.264,2.264,0,0,0,2.264-2.264v-14.861a5.425,5.425,0,0,1,2.038-4.241,5.5,5.5,0,0,1,4.653-1.063A5.6,5.6,0,0,1-286.77,2720.428Z",
    transform: "translate(302.181 -2710.202)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2012",
    "data-name": "Trac\\xE9 2012",
    d: "M-258.163,2770.25l-6.821-6.635a2.263,2.263,0,0,0-3.2.044,2.263,2.263,0,0,0,.044,3.2l6.821,6.635a2.255,2.255,0,0,0,1.578.641,2.256,2.256,0,0,0,1.623-.686A2.264,2.264,0,0,0-258.163,2770.25Z",
    transform: "translate(278.894 -2747.046)",
    fill: "url(#linear-gradient-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecommendationsSquareIcon);
export default __webpack_public_path__ + "static/media/recommendationsSquareIcon.0e9ce8cd303570a47a4be572e56db91a.svg";
export { ForwardRef as ReactComponent };